import { render, staticRenderFns } from "./QtiImportModal.vue?vue&type=template&id=05172341&scoped=true"
import script from "./QtiImportModal.vue?vue&type=script&lang=js"
export * from "./QtiImportModal.vue?vue&type=script&lang=js"
import style0 from "./QtiImportModal.vue?vue&type=style&index=0&id=05172341&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05172341",
  null
  
)

export default component.exports